import _ from 'lodash';
import {sortString} from '../../../../../../services/Helpers';

export const getCategoryGroup = (course) => course.box_categories?.box_categories_groups?.[0] ?? null;
export const getServiceType = (course) => course.box_categories ?? null;
export const getSeriesEventsCount = (course) => course.series_events?.length ?? 0;

export const sortCourses = (courses) => {
    return _.orderBy(
        courses,
        [
            course => sortString(getServiceType(course)?.name ?? ''),
            course => sortString(course.series_name ?? ''),
        ],
        ['asc', 'asc'],
    );
};

export const groupCoursesForTable = (courses) => {
    const sortedCourses = sortCourses(courses);
    const groups = [];
    let currentServiceTypeId = null;
    let currentGroup = null;

    sortedCourses.forEach(course => {
        const serviceTypeId = getServiceType(course)?.id ?? 'no-service-type';
        if (serviceTypeId !== currentServiceTypeId) {
            if (currentGroup) {
                groups.push(currentGroup);
            }
            currentServiceTypeId = serviceTypeId;
            currentGroup = {
                serviceTypeName: getServiceType(course)?.name ?? '',
                courses: [course],
                key: String(serviceTypeId),
            };
        } else {
            currentGroup.courses.push(course);
        }
    });

    if (currentGroup) {
        groups.push(currentGroup);
    }

    return groups;
};
